import type { IconProps } from './icons.types';

export function PlusIcon({ size = 16 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 13 13" fill="currentColor" aria-hidden="true">
      <path d="M5.75 7.25H0V5.75H5.75V0H7.25V5.75H13V7.25H7.25V13H5.75V7.25Z" />
    </svg>
  );
}
